import React from 'react'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'
import { ArrowRight, ArrowLeft } from 'lucide-react'

interface PromptInputProps {
  value: string
  onChange: (value: string) => void
  onNext: () => void
  showPrevious?: boolean
  onPrevious?: () => void
}

const PromptInput = ({ 
  value, 
  onChange, 
  onNext,
  showPrevious = false,
  onPrevious 
}: PromptInputProps) => {
  return (
    <div className="w-full">
      <Card className="p-6">
        <div className="space-y-4 max-w-4xl mx-auto">
          <h2 className="text-lg font-bold text-gray-800">创作提示</h2>
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-600">
              描述你想创作的故事内容
            </label>
            <textarea
              value={value}
              onChange={(e) => onChange(e.target.value)}
              className="w-full min-h-[160px] p-4 rounded-xl border border-gray-200 focus:border-primary/20 focus:ring-2 focus:ring-primary/20 transition-all resize-none"
              placeholder="例如：一只小兔子在森林里迷路了，遇到了热心的小松鼠..."
            />
          </div>
          
          <div className="flex justify-between items-center">
            {showPrevious ? (
              <Button
                variant="outline"
                onClick={onPrevious}
                className="flex items-center gap-2"
              >
                <ArrowLeft className="w-4 h-4" />
                <span>上一步</span>
              </Button>
            ) : <div />}

            <Button
              onClick={onNext}
              className="flex items-center gap-2 bg-gradient-to-r from-primary via-accent to-secondary hover:opacity-90"
              disabled={!value.trim()}
            >
              <span>下一步</span>
              <ArrowRight className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </Card>
    </div>
  )
}

export default PromptInput 